import type { DemoLanguage } from '@/types/demo';

export type DemoPulseContent = {
  question: string;
  answers: [string, string, string, string, string];
};

export type DemoInsightContent = {
  driver: string;
  question: string;
  training: string;
};

/**
 * Default Pulse copy — manager satisfaction (matches mailer demoPulsePayload).
 */
export function getDefaultPulseContent(language: DemoLanguage): DemoPulseContent {
  if (language === 'en') {
    return {
      question: 'Overall, how satisfied are you with your manager?',
      answers: [
        'Very satisfied',
        'Satisfied',
        'Neutral',
        'Dissatisfied',
        'Very dissatisfied',
      ],
    };
  }

  return {
    question: '¿En general, cómo de satisfecho estás con tu jefe?',
    answers: [
      'Muy satisfechx',
      'Satisfechx',
      'Intermedio',
      'Insatisfechx',
      'Muy insatisfechx',
    ],
  };
}

/**
 * Default Insight v3 copy — driver / affected question / training action.
 */
export function getDefaultInsightContent(language: DemoLanguage): DemoInsightContent {
  if (language === 'en') {
    return {
      driver: 'We think agile',
      question: 'In my team, we adapt quickly to changes and priorities',
      training: 'Assign micro-training of Owning change.',
    };
  }

  return {
    driver: 'We think agile',
    question: 'In my team, we adapt quickly to changes and priorities',
    training: 'Asignar micro-training de Owning change.',
  };
}
